/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Annuleren"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Je hebt een zakelijke rechtvaardiging verkregen voor toegang tot klantgegevens"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Je downloadactiviteit wordt geregistreerd en bijgehouden voor beveiligingsdoeleinden"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Wil je doorgaan?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Door te downloaden, ga je ermee akkoord dat:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
